// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getProjectAuditEvents } from '@/audit/api/get-project-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { NotFoundErrorBoundary } from '@/components/not-found-error-boundary';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectKey/audit')({
  component: ProjectAuditRoute,
});

function ProjectAuditRoute() {
  const { projectKey } = Route.useParams();

  return (
    <NotFoundErrorBoundary
      entityType="project"
      listPath="/projects"
      listLabel="Go to projects"
    >
      <ProjectAuditContent projectKey={projectKey} />
    </NotFoundErrorBoundary>
  );
}

function ProjectAuditContent(props: { projectKey: string }) {
  const { data } = useSuspenseQuery({
    queryKey: ['project', props.projectKey, 'audit'],
    queryFn: () => getProjectAuditEvents(props.projectKey),
    retry: false,
  });

  return (
    <HardfinTabCardWrapper title="Audit log">
      <Stack spacing={2} paddingTop={2}>
        {data.events.map((event) => (
          <AuditEventListItem key={event.id} event={event} />
        ))}
      </Stack>
    </HardfinTabCardWrapper>
  );
}
